import { X, Download, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePWA } from "@/hooks/usePWA";

const PWAInstallPrompt = () => {
  const { 
    canInstall, 
    isIOS, 
    showInstallBanner, 
    promptInstall, 
    dismissInstallBanner,
    isStandalone 
  } = usePWA();

  // No mostrar si ya está instalado o en standalone
  if (isStandalone) return null;

  // Banner para Android/Chrome
  if (canInstall && showInstallBanner) {
    return (
      <div className="fixed bottom-20 left-4 right-4 z-50 animate-slide-up md:hidden">
        <div className="bg-card border border-border rounded-2xl shadow-lg p-4">
          <button 
            onClick={dismissInstallBanner}
            className="absolute top-3 right-3 p-1 rounded-full hover:bg-muted"
          >
            <X className="h-4 w-4 text-muted-foreground" />
          </button>
          
          <div className="flex items-start gap-3">
            <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
              <Download className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-sm">Instala TicoMarket</h3>
              <p className="text-xs text-muted-foreground mt-0.5">
                Accede más rápido y recibe notificaciones de tus pedidos
              </p>
            </div>
          </div>
          
          <div className="flex gap-2 mt-3">
            <Button 
              variant="outline" 
              size="sm" 
              className="flex-1 h-10 text-xs"
              onClick={dismissInstallBanner}
            >
              Ahora no
            </Button>
            <Button 
              size="sm" 
              className="flex-1 h-10 text-xs"
              onClick={promptInstall}
            >
              Instalar App
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Instrucciones para iOS
  if (isIOS && showInstallBanner) {
    return (
      <div className="fixed bottom-20 left-4 right-4 z-50 animate-slide-up md:hidden">
        <div className="bg-card border border-border rounded-2xl shadow-lg p-4">
          <button 
            onClick={dismissInstallBanner}
            className="absolute top-3 right-3 p-1 rounded-full hover:bg-muted"
          >
            <X className="h-4 w-4 text-muted-foreground" />
          </button>
          
          <div className="flex items-start gap-3">
            <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
              <Smartphone className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-sm">Instala TicoMarket</h3>
              <p className="text-xs text-muted-foreground mt-1">
                Toca <span className="inline-flex items-center px-1 bg-muted rounded text-foreground">
                  Compartir
                </span> y luego <span className="font-medium">"Agregar a Inicio"</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default PWAInstallPrompt;
